import type {TenantBankAccount} from './TenantBankAccount';

export type BalanceBankTransferPaymentRequestBody = {
  paymentDiscriminator: BalanceBankTransferPaymentRequestBody.paymentDiscriminator;
  paymentMethod: BalanceBankTransferPaymentRequestBody.paymentMethod;
  dueDate: string;
  tenantBankAccount: TenantBankAccount | null;
  comment: string;
  exchangeRate: string | null;
  supplierInvoiceNumber: string | null;
  dateOfTaxableSupply: string | null;
};

export namespace BalanceBankTransferPaymentRequestBody {
  export enum paymentDiscriminator {
    BALANCE = 'BALANCE',
  }

  export enum paymentMethod {
    BANK_TRANSFER = 'BANK_TRANSFER',
  }
}
